export enum IconSize {
  xs = 'xs',
  s = 's',
  m = 'm',
  ml = 'ml',
  l = 'l',
  xl = 'xl',
  xxl = 'xxl',
}
